import React, { Fragment, useEffect, useState } from 'react';
import { EyeInvisibleOutlined } from '@ant-design/icons';
import { BOTTOM_INDENTS, COLORS } from '@constants';
import { Button, Icon, Typography } from '@ui';
import { Col } from 'antd';
import { StyledApiKey, StyledApiKeyInfo } from './styled';

export const ApiKeyInfo = ({ apiKey, isValid }) => {
    const [masked, setMasked] = useState(true);
    const maskedApiKey = apiKey
        ? `${'*'.repeat(apiKey.split('-')[0].length)}-${apiKey.split('-')[1].slice(0, 2)}${'*'.repeat(
              apiKey.split('-')[1].length - 2
          )}`
        : '';

    const [showCopiedMessage, setShowCopiedMessage] = useState(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowCopiedMessage(null);
        }, 1000);

        return () => {
            clearTimeout(timer);
        };
    }, [showCopiedMessage]);
    return (
        <Fragment>
            <Typography.Text
                data-e2e='integrations_api-key_block-title'
                style={BOTTOM_INDENTS.M}
                color={COLORS.$gray60Black}
                type='body2'
            >
                Connect to Klickly’s API using your secret API key:
            </Typography.Text>
            <StyledApiKey data-e2e='integrations_api-key_field' align='middle'>
                <Col>
                    <Button
                        data-e2e='integrations_show-api-key_btn'
                        type='link'
                        onClick={() => setMasked(!masked)}
                        icon={
                            <Icon
                                size='24px'
                                color={COLORS.$gray60Black}
                                component={() => (masked ? <Icon.EyeIcon /> : <EyeInvisibleOutlined />)}
                            />
                        }
                    />
                </Col>
                <Col flex='auto'>
                    <Typography.Text data-e2e='integrations_api-key_value' type='descriptor1'>
                        {masked ? maskedApiKey : apiKey}
                    </Typography.Text>
                </Col>
                <Col>
                    <Button.Copy value={apiKey} />
                </Col>
            </StyledApiKey>
            <StyledApiKeyInfo data-e2e='integrations_api-key-info_block' $isValid={isValid}>
                {!isValid && (
                    <Typography.Text color={COLORS.$tartRed} type='badgeMedium' style={BOTTOM_INDENTS.XXS}>
                        API key:
                    </Typography.Text>
                )}
                <Typography.Text
                    data-e2e='integrations_api-key-info_block-description'
                    align={isValid ? 'center' : 'left'}
                    color={isValid ? COLORS.$robinBlue : COLORS.$tartRed}
                    type='descriptor1'
                >
                    An API key is a unique identifier provided to users for accessing a service&apos;s API. It acts as a
                    digital key, granting permission to interact with the service programmatically. This key is
                    essential for authentication and authorization, ensuring that only authorized individuals or
                    applications can access the service&apos;s data or functionalities. In essence, the key serves as a
                    security measure, controlling access and safeguarding sensitive information from unauthorized use.
                </Typography.Text>
            </StyledApiKeyInfo>
        </Fragment>
    );
};
